import { Sparklines, SparklinesCurve } from "react-sparklines";
import { MarketTableListContainer } from "./../styles";
import { useChartData } from "@app/hooks/binance/chartdata";

const SparkLine = ({ symbol }) => {
  const { data } = useChartData(symbol || "BTCUSDT");

  return (
    <MarketTableListContainer>
      <Sparklines data={data}>
        <SparklinesCurve />
      </Sparklines>
    </MarketTableListContainer>
  );
};

export default SparkLine;
